import React, { Component } from "react";
import { Spinner } from "react-bootstrap";
import httpService from "../../services/httpService";
import config from "../../config.json";
import { Button } from "react-bootstrap";
import { Modal } from "react-bootstrap";
import CasovaniDochazkaVypis from "./CasovaniDochazkaVypis";

class CasovaniDochazka extends Component {
  state = {};

  componentDidMount = () => {
    this.nahrajVypis();
  };

  nahrajVypis = async () => {
    const vypis = await httpService.post(
      config.apiEndpoint + "casovani/dochazkaVypis.php"
    );
    this.setState({ prehled: vypis.data.vypis, loaded: true });
  };

  render() {
    const { loaded, prehled, showPruser } = this.state;
    return (
      <React.Fragment>
        {loaded ? (
          prehled && prehled.length > 0 ? (
            <React.Fragment>
              <Modal
                dialogClassName="modal-90w"
                show={showPruser}
                onHide={() => this.setState({ showPruser: null })}
              >
                <Modal.Header closeButton>
                  Detail účasti klienta na prodecurách
                </Modal.Header>
                <Modal.Body>
                  {showPruser && (
                    <CasovaniDochazkaVypis idpobytu={showPruser} />
                  )}
                </Modal.Body>
              </Modal>
              <table className="table color-table primary-table">
                <thead>
                  <tr>
                    <th>ID pobytu</th>
                    <th>Klient</th>
                    <th>Poslední insident</th>
                    <th>Včasné příchody</th>
                    <th>Pozdní příchody</th>
                    <th>Neúčast</th>
                  </tr>
                </thead>
                <tbody>
                  {prehled.map((p) => (
                    <tr key={p.idpobytu}>
                      <td>{p.idpobytu}</td>
                      <td>
                        <Button
                          style={{
                            padding: "0px",
                            margin: "0px",
                            display: "inline",
                            border: "none",
                          }}
                          variant="link"
                          onClick={() =>
                            this.setState({ showPruser: p.idpobytu })
                          }
                        >
                          {p.klient}
                        </Button>
                      </td>
                      <td>
                        {p.max_datum_pruser ? (
                          <span>
                            {p.max_datum_pruser}
                            <div
                              style={{ fontSize: "0.8em" }}
                              className={
                                p.stav === "vubec"
                                  ? "text-danger"
                                  : "text-warning"
                              }
                            >
                              {p.pracoviste}
                              {" | "}
                              {p.cas}
                              {" | "}
                              {p.jmeno}
                            </div>
                          </span>
                        ) : (
                          "neevidujeme"
                        )}
                      </td>
                      <td className="text-right text-success">{p.vcas}</td>
                      <td className="text-right text-warning">{p.pozde}</td>
                      <td className="text-right text-danger">{p.vubec}</td>
                    </tr>
                  ))}
                </tbody>
              </table>
            </React.Fragment>
          ) : (
            <div className="alert alert-danger">Nic tu není...</div>
          )
        ) : (
          <div className="text-warning">
            <Spinner animation="grow" size="sm" variant="warning" />
            Loading...
          </div>
        )}
      </React.Fragment>
    );
  }
}

export default CasovaniDochazka;
